import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { AlertType, RelatorioConsultaVendas, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { createTheme, ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { Funcoes } from '../../Utils/Funcoes'
import moment from 'moment'
import { IoReceipt } from 'react-icons/io5'
import { Tooltip } from 'react-tooltip'
import { TbShoppingCartOff } from 'react-icons/tb'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { VendasService } from '../../Pages/Vendas/vendasService'
import { FaCheck } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

type Props = {
    venda: RelatorioConsultaVendas[],
    imprimir: (id: any) => void,
    tipo: TipoStatus,
    handleUpdateVendasList: () => void,
}

type VisibilityState = Record<string, boolean>

export type TipoStatus = | "N" | "F"

interface RowData {

    id: number,
    data_hora: string,
    vl_bruto: number,
    qtd_itens: number,
    vl_desc: number,
    vl_acre: number,
    vl_liquido: number,
    id_user_insert: number,
    id_cliente: number,
    status: string,
    observacao: string,
    vl_bc_icms: number,
    vl_icms: number,
    vl_bc_pis_cofins: number,
    vl_pis: number,
    vl_cofins: number,
    vl_bc_st: number,
    vl_st: number,
    vl_frete: number,
    id_user_last_update: number,
    dt_last_update: string,
    dh_faturamento: string,
    num_nf: number,
    id_user_faturamento: number,
    id_empresa: 10,
    nome_consumidor: string,
    cpf_cnpj: string,
    rua_consumidor: string,
    cep_consumidor: string,
    numero_consumidor: string,
    bairro_consumidor: string,
    uf_consumidor: string,
    id_cidade_consumidor: number,
    id_user_cancel: number,
    dh_cancel: string,
    id_user_venda: number,
    name_user_insert: string,
    name_user_venda: string,
    itens: [
        {
            id: number,
            nitem: number,
            id_produto: number,
            desc_prod: string,
            cod_barra: string,
            qtde: number,
            vl_unit: number,
            vl_custo: number,
            vl_tot: number,
            vl_desc: number,
            vl_bc_icms: number,
            p_icms: number,
            cst_icms: string,
            origem_produto: string,
            vl_icms: number,
            vl_bc_pis_cofins: number,
            p_pis: number,
            vl_pis: number,
            p_cofins: number,
            vl_cofins: number,
            cst_pis_cofins: string,
            vl_bc_st: number,
            vl_st: number,
            vl_frete: number,
            status: string,
            dh_insert: string,
            dh_cancel: string,
            id_user_cancel: number,
            id_user_last_update: number,
            dt_last_update: string
        }
    ],
    pagamentos: [
        {
            id_fpagto: number,
            valor: number,
            descricao: string
        }
    ]
}

export const GridConsultaVendas = React.memo(({ venda, imprimir, tipo, handleUpdateVendasList }: Props) => {

    const defaultJson = useMemo(() => {
        return (

            {
                acao: true,
                id: true,
                data_hora: true,
                nome_consumidor: true,
                qtd: true,
                vl_liquido: true,
                name_user_insert: true,
            }
        )
    }, [])

    const [idVenda, setIdVenda] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")

    const [vendas, setVendas] = useState<RelatorioConsultaVendas[]>([])
    //const [relatorio, setRelatorio] = useState({})
    const [nomeVenda, setNomeVenda] = useState("")

    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    let user = useSelector(state => selectUser(state))

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setVendas([])
    }, [tipo])

    useEffect(() => {
        setVendas(venda)
    }, [venda])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- IMPRIMIR -----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleImprimir = async (id: any) => {

        if (imprimir) {
            imprimir(id)
        }

    }


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaVendaEdit = (id: number) => {
        navigate(`/venda/edit/${id}`)
    }


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi = await VendasService.CancelarVenda(idVenda, senha, motivo)

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Venda cancelada com sucesso`)

                handleUpdateVendasList()

                //setModalShow(false)

            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
            }

        } catch (error) {
            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível cancelar a venda. Por favor, tente novamente`)
        }

    }, [idVenda])

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)

        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeVenda("")
        }

    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeVenda("")
    }, [])

    let colunasArray: MRT_ColumnDef<RelatorioConsultaVendas>[] = []

    const colunas = useMemo<MRT_ColumnDef<RelatorioConsultaVendas>[]>(() => [

        {
            accessorKey: 'acao', header: 'Ações', visibleInShowHideMenu: true, size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                const handleFinalizarVendaClick = () => {
                    navegarTelaVendaEdit(rowData.id)
                }

                const handleIprimirClick = () => {

                    handleImprimir(rowData.id)

                    if (cell.row.getIsExpanded()) {
                        cell.row.toggleExpanded(false) // Fecha a sub-row
                    }

                }

                const handleExcluirClick = () => {

                    const timerExcluir = setTimeout(() => {

                        setIdVenda(rowData.id)
                        setNomeVenda(rowData.id.toString())
                        setModalShow(true)

                        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

                        if (divPerfil) {
                            divPerfil.classList.add('hidden')
                        }

                        let menuFiltro = document.getElementById("divMenuFiltroConsultaVendas") as HTMLDivElement
                        let menuInputs = document.getElementById("divInputsConsultaVendas") as HTMLDivElement
                        let bodySearchCliente = document.getElementById("bodySearchBox-cliente") as HTMLDivElement
                        let bodySearchVendedor = document.getElementById("bodySearchBox-vendedor") as HTMLDivElement

                        if (menuFiltro) {

                            bodySearchCliente.classList.remove("visible")
                            bodySearchVendedor.classList.remove("visible")

                            menuInputs.classList.add("invisible")

                            const timer = setTimeout(() => {
                                menuFiltro.classList.remove("max-h-[600px]")
                                menuFiltro.classList.add("max-h-[0px]")
                                clearTimeout(timer)
                            }, 100)
                        }

                        clearTimeout(timerExcluir)
                    }, 0)

                }

                return (

                    <>
                        <div className={`flex justify-start w-full`}>

                            <button
                                onClick={handleFinalizarVendaClick} data-tooltip-id={'tooltip-finalizarVendas-' + rowData.id} id={'btn-finalizarVendas-' + rowData.id}
                                className={`${tipo === "N" ? 'block' : 'hidden'} flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-green-600 w-[30px] h-[30px] rounded-md 
                                          bg-green-500`}>
                                <FaCheck size="20px" />
                                <Tooltip style={{ backgroundColor: 'rgb(22, 163, 74)' }} id={'tooltip-finalizarVendas-' + rowData.id} anchorSelect={'#btn-finalizarVendas-' + rowData.id} positionStrategy="fixed" place='top-start'  >
                                    <span className={`font-sans font-medium text-[13px]`}>Finalizar Venda</span>
                                </Tooltip>
                            </button>

                            <button
                                onClick={handleIprimirClick} data-tooltip-id={'tooltip-consultaVendas-' + rowData.id} id={'btn-consultaVendas-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                          bg-sky-500 ml-2`}>
                                <IoReceipt size="20px" />
                                <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-consultaVendas-' + rowData.id} anchorSelect={'#btn-consultaVendas-' + rowData.id} positionStrategy="fixed" >
                                    <span className={`font-sans font-medium text-[13px]`}>Imprimir</span>
                                </Tooltip>
                            </button>

                            <button
                                onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                          bg-red-500 ml-2`} >
                                <TbShoppingCartOff size="20px" />
                                <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed" place='top-end' >
                                    <span className={`font-sans font-medium text-[13px]`}>Cancelar Venda</span>
                                </Tooltip>
                            </button>

                        </div>
                    </>

                )
            }
        },

        {
            accessorKey: 'id', visibleInShowHideMenu: true, header: 'Venda', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.id ? rowData.id : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'data_hora', visibleInShowHideMenu: true, header: 'Data da Venda', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.data_hora ? moment(rowData.data_hora).format("DD/MM/YYYY") : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'nome_consumidor', visibleInShowHideMenu: true, header: 'Cliente', size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.nome_consumidor ? rowData.nome_consumidor : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'qtd', visibleInShowHideMenu: true, header: 'Qtd itens', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.qtd_itens ? rowData.qtd_itens : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'vl_bruto', visibleInShowHideMenu: true, header: 'Valor Bruto da Venda', size: 200, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.vl_bruto ? Funcoes.numberFormat(rowData.vl_bruto, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'vl_desc', visibleInShowHideMenu: true, header: 'Valor do Desconto', size: 200, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.vl_desc ? Funcoes.numberFormat(rowData.vl_desc, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'vl_liquido', visibleInShowHideMenu: true, header: 'Valor Liquido da Venda', size: 200, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.vl_liquido ? Funcoes.numberFormat(rowData.vl_liquido, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'name_user_venda', visibleInShowHideMenu: true, header: 'Vendedor', size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.name_user_venda ? rowData.name_user_venda : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

    ], [venda]
    )

    const table = useMaterialReactTable({
        columns: colunas,
        data: vendas,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },

            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
        initialState: {
            pagination: { pageIndex: 0, pageSize: 10 },  // Define 10 elementos por página
        },
        muiPaginationProps: {
            rowsPerPageOptions: [10],  // Apenas uma opção para o seletor: 10
        },
        // Adicionando a expansão de sub-rows
        renderDetailPanel: ({ row }) => (
            <div className='' style={{ padding: '16px' }} >
                <span className={`text-lg`}>Itens da Venda</span>
                <table className={`w-full mt-2`}>
                    <thead className={`h-[30px] bg-blue-800 dark:bg-[#3498DB] text-slate-200`}>
                        <tr>
                            <th className={`w-[40%] text-start px-2 border border-slate-300  dark:border-slate-700`}>Descrição</th>
                            <th className={`w-[15%] text-start px-2 border border-slate-300  dark:border-slate-700`}>Código de Barras</th>
                            <th className={`w-[15%] text-end px-2 border border-slate-300  dark:border-slate-700`}>Quantidade</th>
                            <th className={`w-[15%] text-end px-2 border border-slate-300  dark:border-slate-700`}>Valor Unit</th>
                            <th className={`w-[15%] text-end px-2 border border-slate-300  dark:border-slate-700`}>Total</th>
                        </tr>
                    </thead>
                    <tbody className={`bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>
                        {row.original?.itens.map((subLinha: any, index: any) => (
                            <tr key={index} className={`h-[40px] hover:bg-slate-200 dark:hover:bg-slate-500`}>
                                <td className={`w-[40%] text-start px-2 border border-slate-300 dark:border-slate-700`}>{subLinha.desc_prod}</td>
                                <td className={`w-[15%] text-start px-2 border border-slate-300 dark:border-slate-700`}>{subLinha.cod_barra}</td>
                                <td className={`w-[15%] text-end px-2 border border-slate-300 dark:border-slate-700`}>{Funcoes.numberFormat(subLinha.qtde, 'decimal')}</td>
                                <td className={`w-[15%] text-end px-2 border border-slate-300 dark:border-slate-700`}>{Funcoes.numberFormat(subLinha.vl_unit, 'currency')}</td>
                                <td className={`w-[15%] text-end px-2 border border-slate-300 dark:border-slate-700`}>{Funcoes.numberFormat(subLinha.vl_tot, 'currency')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        ),
        //getRowCanExpand: (row) => !!row.original.subLinhas && row.original.subLinhas.length > 0,
    })

    return (
        <>

            <ThemeProvider theme={theme}>
                <MaterialReactTable table={table} />
            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja cancelar a venda - ${nomeVenda || ''}?`}
                cancelarVenda={true}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

        </>
    )

})